<template>
    <v-card class="mt-3" v-if="item">
    <!-- <v-row justify="space-between" class="mx-0"><h2>Import contacts</h2><action-button icon="$close" tooltip="Close" @click="close"/></v-row> -->
    <v-card-title><span><slot name="title" /></span><v-spacer /><action-button icon="$close" :tooltip="$t('dialog.close')" @click="close"/></v-card-title>
    <v-stepper v-if="isActive"
        id="pfid1618852734" 
        v-model="step"
        vertical
        class="elevation-0"
    >
    <v-stepper-step
      step="1"
      :complete="step > 1"
    >{{$t('form.selectFile')}}</v-stepper-step>
    <v-stepper-content step="1">
      <v-form ref="uform" @submit.prevent="upload()">
      <v-file-input
        id="pfid1618852751" 
        :label="$t('imports.unsubscribe.fileLabel')"
        :accept="accept"
        :rules="[(v) => !!v || $t('form.rules.required'), value => !value || value.size < 10000000 || $t('form.rules.fileSize', {size: '10 MB'})]"
        show-size
        truncate-length="30"
        v-model="file"
    ></v-file-input>
    
   
      <v-btn
      id="pfid1618852761" 
      type="submit"
        color="primary"
        :disabled="!file"
      >
        <v-icon left>$upload</v-icon>{{$t('dialog.continue')}}
      </v-btn>
      </v-form>
    </v-stepper-content>

    <v-stepper-step 
      step="2"
      :complete="step > 2"
    >{{$t('form.upload')}}</v-stepper-step>

    <v-stepper-content step="2">
      <v-progress-linear v-model="uploadProgress"></v-progress-linear>
    </v-stepper-content>
  
  <v-stepper-step
      step="3"
      :complete="step > 3"
    >
      {{ $t('imports.review') }}
    </v-stepper-step>

    <v-stepper-content step="3">
      <template v-if="stats">
        <v-list-item><v-list-item-icon><v-icon>$rows</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.rows')}}</v-list-item-subtitle><v-list-item-title>{{stats.rows}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.emails')}}</v-list-item-subtitle><v-list-item-title>{{stats.emails}}</v-list-item-title></v-list-item-content></v-list-item>
      </template>
      <v-btn
        id="pfid1618852796" 
        color="primary"
        :disabled="error"
        @click="step = 4; createJob()"
      >{{$t('dialog.confirm')}}</v-btn>
      <v-btn id="pfid1618852833" text @click="reset()">{{$t('dialog.back')}}</v-btn>
    </v-stepper-content>
    <v-stepper-step
      step="4"
      :complete="step > 4"
    >{{$t('imports.unsubscribe.unsubscribe')}}</v-stepper-step>
    <v-stepper-content step="4">
      <v-progress-linear v-if="job" v-model="job.progress"></v-progress-linear>
    </v-stepper-content>
    <v-stepper-step
      step="5"
      :complete="step > 5"
    >{{$t('common.results')}}</v-stepper-step>
    <v-stepper-content step="5">
          <template v-if="job && job.data">
            <v-list>
                <v-list-item><v-list-item-icon><v-icon>$ok</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.unsubscribe.removed')}}</v-list-item-subtitle><v-list-item-title>{{job.data.removed}}</v-list-item-title></v-list-item-content></v-list-item>
                <v-list-item><v-list-item-icon><v-icon>$nok</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.unsubscribe.notFound')}}</v-list-item-subtitle><v-list-item-title>{{job.data.notFound}}</v-list-item-title></v-list-item-content></v-list-item>
            </v-list>
          </template>
          <v-btn id="pfid1618852847" color="primary" @click="close">{{$t('dialog.close')}}</v-btn>
          <v-btn id="pfid1618852851" text @click="reset()">{{$t('dialog.startOver')}}</v-btn>
    </v-stepper-content>
    </v-stepper>
    <v-card-text v-else >
    <v-alert color="orange" type="warning" border="left" outlined>
      <span v-if="isIncomplete">{{ $t('imports.incomplete') }}</span>
      <span v-else>{{$t('dashboard.inactive')}}</span>
    </v-alert>
    </v-card-text>
    </v-card>
    <v-skeleton-loader type="heading,card@3" v-else />
</template>
<script>

import { mapState, mapGetters } from "vuex";
export default {
    name: 'ContactUnsubscribe',
    mixins: [],
    props: {
      
      error: Boolean,
      analysis: Object,
    },
    data() {
        return {
            type: "delete",
            accept: "text/csv",
            step: 1,
            file: null,
        }
    },
    computed: {
        ...mapState('domains', ['item']),
        ...mapGetters('domains', ['isActive', 'isIncomplete']),
        ...mapState('imports', ['job', 'stats', 'uploadProgress']),
    },
    watch: {
    },
    methods: {
        close() {
          this.reset();
          this.$store.dispatch('domains/get', { id: this.item.id });
          this.$router.go(-1);
        },
        upload() {
            // start upload
            if(!this.$refs.uform.validate()) {
              return;
            }
            this.step = 2;
            this.$store.dispatch('imports/uploadFile', { domain: this.item.id, type: this.type, file: this.file }).then(() => { this.step = 3 });
        },
        reset() {
            this.step = 1;
            this.file = null;
            this.$store.dispatch('imports/reset');
        },
        createJob() {
            this.$store.dispatch('imports/createJob', { domain: this.item.id }).then(() => { setTimeout(this.checkJob, 5000); });
            // start timer - check job
        },
        checkJob() {
            console.debug('Checking job...');
            this.$store.dispatch('imports/updateJob').then((job) => {
                if( job.result == 'COMPLETED') {
                    this.step+=1;
                } else {
                    setTimeout(this.checkJob, 5000);
                }
            });
        }
    }
}
</script>